import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_academic from "../../core/service/api_academic";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { Listbox } from "@headlessui/react";
import { setLoading } from "../../core/feature/config/configSlice";
import TabsMobile from "../__template/TabsMobileComponent";
import mon from "../../assets/images/icon_academic/mon.svg";
import tue from "../../assets/images/icon_academic/tue.svg";
import wed from "../../assets/images/icon_academic/wed.svg";
import thu from "../../assets/images/icon_academic/thu.svg";
import fri from "../../assets/images/icon_academic/fri.svg";
import sat from "../../assets/images/icon_academic/sat.svg";
import sun from "../../assets/images/icon_academic/sun.svg";
import next from "../../assets/images/icon_academic/next-arrow.svg";
import prev from "../../assets/images/icon_academic/prev-arrow.svg";
import moment from "moment";
import { useTranslation } from "react-i18next";
import PullToRefresh from "react-simple-pull-to-refresh";

const ScheduleMobile = () => {
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const lang: String = useAppSelector((state) => state.language.language);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [accounts, setAccounts] = useState<any>([]);
  const [companyId, setCompanyId] = useState("");
  const [callerId, setCallerId] = useState("");
  const [schedule, setSchedule] = useState<any>([]);
  const [lessonList, setLessonList] = useState<any>([]);
  const [isEmpty, setIsEmpty] = useState(true);
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(moment());
  const [selectedDay, setSelectedDay] = useState(
    moment(moment().day()).format("dddd")
  );
  const [selectedLessonYear, setSelectedLessonYear] = useState(
    moment(moment().day()).format("yyyy")
  );
  const [selectedCallerId, setSelectedCallerId] = useState(
    user.accounts[0].callerIdentities.length > 0
      ? user.accounts[0].callerIdentities[0].callerId
      : ""
  );
  const [selectedCallerName, setSelectedCallerName] = useState(
    user.accounts[0].callerIdentities.length > 0
      ? user.accounts[0].callerIdentities[0].name
      : ""
  );

  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
      getAllAccounts();
      console.log("haioo");

      let temp = selectedDate;
      temp = moment(temp, "DD/MM/YYYY").add(-1, "days");
      setSelectedDay(moment(temp).format("dddd").toString());
    }
  }, [selectedCallerId, selectedDate]);

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
      setSelectedDate(moment());
      getAllAccounts();
    }
  }, [selectedCallerId]);
  useEffect(() => {
    console.log("tes", location.pathname.split("/")[2]);
    if (location.pathname.split("/")[2] != undefined) {
      dispatch(setToken(location.pathname.split("/")[2]));
      API.credentialCheck().then((resCredential) => {
        dispatch(setUser(resCredential.data.user));
        getAllAccounts();
      });
    }
  }, [location.pathname.split("/")[2]]);

  function getAllAccounts() {
    let temp = user.accounts[0].callerIdentities;
    setAccounts(temp);
    getActiveYear();
    getLessonList();
  }

  function getActiveYear() {
    api_academic.getAllYear().then((res: any) => {
      let selectedYear = "";
      res.data.map((item: any) => {
        if (item.defaultYear) {
          selectedYear = item.year;
        }
      });

      let dayname = moment(selectedDate)
        .locale("en")
        .format("dddd")
        .toLocaleUpperCase();
      console.log("dayname", dayname);
      getAllSchedule(selectedYear, selectedCallerId, dayname);
      setSelectedLessonYear(selectedYear);
    });
  }
  const handleRefresh = async () => {
    getAllAccounts();
  };

  function getLessonList() {
    api_academic.getLessonList().then((res: any) => {
      let temp = res.data.content;
      setLessonList(temp);
    });
  }

  function getAllSchedule(year: any, callerId: any, day: any) {
    dispatch(setLoading(true));
    api_academic
      .getSchedule(year, callerId, day)
      .then((res) => {
        dispatch(setLoading(false));
        console.log(res.data.content[0].lessons.length + " length lesson");
        setSchedule(res.data.content);
        if (res.data.content[0].lessons.length > 0) {
          setIsEmpty(false);
        } else {
          setIsEmpty(true);
        }
      })
      .catch((e) => {
        dispatch(setLoading(false));
        console.log(e);
        setSchedule([]);
        setIsEmpty(true);
      });
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getLessonName(id: any) {
    let temp = "";
    lessonList.map((item: any) => {
      if (item._id == id) {
        temp = item.lessonName;
      }
    });
    return temp;
  }

  function prevDay() {
    let temp = selectedDate;
    temp = moment(temp, "DD/MM/YYYY").add(-1, "days");
    setSelectedDate(temp);
    setSelectedDay(moment(temp).format("dddd").toString());
  }

  function nextDay() {
    let temp = selectedDate;
    temp = moment(temp, "DD/MM/YYYY").add(1, "days");
    setSelectedDate(temp);
    setSelectedDay(moment(temp).format("dddd").toString());
  }

  function getAsset() {
    let str = moment(selectedDate)
      .locale("en")
      .format("ddd")
      .toLocaleLowerCase();
    switch (str) {
      case "mon":
        return mon;
      case "tue":
        return tue;
      case "wed":
        return wed;
      case "thu":
        return thu;
      case "fri":
        return fri;
      case "sat":
        return sat;
      case "sun":
        return sun;
      default:
        return str;
    }
  }

  function dayName() {
    return moment(selectedDate).locale("en").format("ddd").toLocaleLowerCase();
  }

  const funBg = useMemo(() => {
    let str = moment(selectedDate)
      .locale("en")
      .format("ddd")
      .toLocaleLowerCase();
    return "bg-" + str;
  }, [selectedDate]);

  return (
    <>
      <div className="relative min-h-screen h-full bg-psp-primary pb-10">
        <div className="bg-white px-8 pt-8 pb-3  sticky top-0 z-50">
          <TabsMobile
            name={`${t("SCHEDULE.title")}`}
            backUrl={"home"}
          ></TabsMobile>
        </div>
        <div className="min-h-screen h-full mb-6 px-4 py-6 bg-psp-primary top-to-bottom">
          <PullToRefresh className="text-center" onRefresh={handleRefresh}>
            <section className="mt-1">
              <div className="px-3 bg-white rounded-lg">
                <select
                  name=""
                  id=""
                  className="w-full py-2 bg-white"
                  onChange={(item) => setSelectedCallerId(item.target.value)}
                >
                  {accounts.map((item: any) => {
                    return (
                      <option value={item.callerId} key={item.callerId}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="py-2 w-full">
                <img src={getAsset()} className="object-contain w-full" />
              </div>
              <div className="py-2 rounded-lg">
                {/* <div className={ `rounded-t-lg px-4 py-1 text-white ${funBg}`}> */}
                <div
                  className={`rounded-t-lg px-4 py-1 text-white ${
                    dayName() == "mon"
                      ? "bg-mon"
                      : dayName() == "tue"
                      ? "bg-tue"
                      : dayName() == "wed"
                      ? "bg-wed"
                      : dayName() == "thu"
                      ? "bg-thu"
                      : dayName() == "fri"
                      ? "bg-fri"
                      : dayName() == "sat"
                      ? "bg-sat"
                      : "bg-sun"
                  }`}
                >
                  {dayName() == "mon"
                    ? t("SCHEDULE.day.mon")
                    : dayName() == "tue"
                    ? t("SCHEDULE.day.tues")
                    : dayName() == "wed"
                    ? t("SCHEDULE.day.wed")
                    : dayName() == "thu"
                    ? t("SCHEDULE.day.thurs")
                    : dayName() == "fri"
                    ? t("SCHEDULE.day.fri")
                    : dayName() == "sat"
                    ? t("SCHEDULE.day.sat")
                    : t("SCHEDULE.day.sun")}
                </div>
                <div className="flex flex-row bg-white py-1 border-b border-black">
                  <div className="w-1/3 text-center">{t("SCHEDULE.time")}</div>
                  <div className="w-2/3 text-center">
                    {t("SCHEDULE.lesson")}
                  </div>
                </div>
                {schedule.length > 0 &&
                  schedule[0].lessons.map((item: any) => {
                    return (
                      <div className="flex flex-row bg-white py-1 ">
                        <div className="w-1/3 text-center">
                          {" "}
                          {String(item.startTime).substring(0, 5)} -{" "}
                          {String(item.endTime).substring(0, 5)}{" "}
                        </div>
                        <div className="w-2/3 text-center flex justify-center align-center ">
                          {" "}
                          {getLessonName(item.lessonId)}{" "}
                        </div>
                      </div>
                    );
                  })}
                {isEmpty == true && (
                  <div className="flex justify-center align-center h-8 bg-white">
                    {t("OTHER.dataNotFound")}
                  </div>
                )}
                <div className="rounded-b-lg bg-white h-2">{/* bottom */}</div>
              </div>
              <div className="flex justify-center my-2">
                <div>
                  <button className="mr-2" onClick={prevDay}>
                    {" "}
                    <img src={prev} alt="" />{" "}
                  </button>
                  <button className="ml-2" onClick={nextDay}>
                    {" "}
                    <img src={next} alt="" />{" "}
                  </button>
                </div>
              </div>
            </section>
          </PullToRefresh>
        </div>
      </div>
    </>
  );
};

export default ScheduleMobile;
